export const formRowsStyles = {
  container: {
    mb: 1,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
    '& > div': {
      flexGrow: 0,
      minWidth: 190,
      flexShrink: 0,
      flexBasis: 0,
    },
  },
  button: {
    flexBasis: 'auto',
    minWidth: 'unset',
    alignSelf: 'center',
  },
  loader: {
    p: 1,
  },
  statusIcon: {
    p: 1,
    fontSize: 48,
  },
  successIcon: {
    color: 'success.main',
  },
};
